import { apiClientPaginated } from '@/lib/api-client';

/** Ops simulation T09 — an offline bill line taxed differently from the product master. */
export interface TaxMismatch {
  id: string;
  bill_id: string;
  bill_number: string;
  location_id: string | null;
  location_name: string | null;
  product_id: string | null;
  product_name: string | null;
  /** Rate the till used offline (what the receipt shows), in percent. */
  charged_gst_rate: number;
  /** The product master's rate when the bill synced. */
  master_gst_rate: number;
  /** Rate stored on the bill line. */
  stored_gst_rate: number;
  /** SYNC = normal offline sync; ACCEPTED_AS_SOLD = an owner accepted a refused bill. */
  source: 'SYNC' | 'ACCEPTED_AS_SOLD';
  cashier_name: string | null;
  created_at: string;
}

export const taxMismatchService = {
  list(params: { page?: number; limit?: number } = {}) {
    const query = new URLSearchParams();
    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    const qs = query.toString();
    return apiClientPaginated<TaxMismatch[]>(`/bills/tax-mismatches${qs ? `?${qs}` : ''}`);
  },
};
